const PickupMemoFields = [
  {
    id: Math.random() * 10,
    name: "Pickup_Memo_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Date",
        label: "Date",
        type: "Date",
      },
      {
        id: Math.random() * 10,
        name: "Vendor_ID",
        label: "Vendor",
        type: "InputDropForQuery",
        clearField: "Branch_Code",
        masterName: "Vendor_Account",
      },
      {
        id: Math.random() * 10,
        name: "Transporter_Doc_No",
        label: "Vendor Doc No",
        type: "text",
        AllCaps: true,
        min: 1,
        max: Infinity,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Vendor",
      //   label: "Vendor",
      //   placeholder: "Vendor",
      //   type: "inputdrop",
      //   autoComplete: "off",
      //   require: true,
      //   isSearchable: true,
      //   dropdowncontent: [
      //     "A TO Z TRANSPORT COMPANY",
      //     "A.T.S LOGISTICS (Noida)",
      //     "A.T.S LOGISTICS (Sumit)",
      //     "AADAM SO UMARFARUK",
      //     "AADIL SAIFULLA SHAIKH",
      //     "AADIL SHAIKH",
      //   ],
      // },
      {
        name: "Mode",
        type: "inputdrop",
        dropdowncontent: ["Truck", "Train", "Flight", "Vessel"],
      },
      {
        id: Math.random() * 10,
        name: "Vehicle",
        label: "Vehicle",
        placeholder: "Vehicle",
        Reference_field: "Mode",
        clearField: "Branch_Code",
        type: "InputDropForQuery",
        masterName: "searchTransportModeData",
      },
      {
        id: Math.random() * 10,
        name: "Drop_At",
        label: "Drop At",
        type: "InputDropForQuery",
        clearField: "Branch_Code",
        masterName: "Warehouse_Name",
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Driver_Name",
        label: "Driver Name",
        type: "InputDropForQuery",
        clearField: "Branch_Code",
        masterName: "DriverNameData",
      },
      {
        id: Math.random() * 10,
        name: "Driver_Number",
        label: "Driver Number",
        type: "number",
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "LSNO",
        label: "Customer Doc No.",
        type: "text",
        AllCaps: true,
        min: 2,
        max: Infinity,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Drop Center",
      //   label: "Drop Center",
      //   placeholder: "Drop Center",
      //   type: "inputdrop",
      //   autoComplete: "off",
      //   require: true,
      //   isSearchable: true,
      //   dropdowncontent: [
      //     "PUNE AIRPORT CNTR ",
      //     "CHENNAI EGMORE STATION",
      //     "BANGALORE AIRPORT",
      //     "GOA AIRPORT",
      //     "DELHI AIRPORT",
      //   ],
      // },

      // {
      //   id: Math.random() * 10,
      //   name: "Driver_Name",
      //   label: "Driver Name",
      //   placeholder: "Driver Name",
      //   type: "inputdrop",
      //   autoComplete: "off",
      //   require: true,
      //   isSearchable: true,
      //   dropdowncontent: ["Driver One", "Driver Two", "Driver Three", "Driver Four", "Driver Five"],
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "Driver_Number",
      //   label: "Driver Number",
      //   placeholder: "Driver Number",
      //   type: "inputdrop",
      //   autoComplete: "off",
      //   require: true,
      //   isSearchable: true,
      //   dropdowncontent: ["5897898754", "7985645689", "7894561234", "8529637415", "7985645895"],
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "Loading_For",
      //   label: "Loading For",
      //   placeholder: "Loading For",
      //   type: "inputdrop",
      //   autoComplete: "off",
      //   require: true,
      //   isSearchable: true,
      //   dropdowncontent: ["Out For Pickup", "Out for Delivery"],
      // },

      // {
      //   id: Math.random() * 10,
      //   name: "Branch_ID",
      //   label: "Branch",
      //   type: "InputDropForQuery",
      //   masterName: "Branch",
      //   min: 2,
      //   max: Infinity,
      //   isRequired: true,
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "To_Weight",
      //   label: "To Weight",
      //   type: "text",
      //   min: 1,
      //   max: Infinity,
      // },
    ],
  },
];

export const PickupMemoConfiguration = [
  {
    id: Math.random() * 10,
    name: "Config_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Default_Voucher_Series",
        label: "Default Voucher Series",
        type: "InputDropForQuery",
        masterName: "Voucher_Series",
        variable: {
          Voucher_Type: "Pickup Memo",
        },
        min: 0,
        max: Infinity,
        isRequired: true,
      },
    ],
  },
];

export const PickupVoucherConfig = [
  {
    id: Math.random() * 10,
    name: "Book_Code_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Voucher_Series",
        label: "Book Code ",
        masterName: "Voucher_Series",
        // dropdowndata: GetBookCodes,
        variable: {
          Voucher_Type: "Pickup Memo",
        },
        type: "InputDropForQuery",
      },
      {
        id: Math.random() * 10,
        name: "Bill_No",
        label: "Next Number",
        type: "number",

        min: 5,
        max: 5,
      },
    ],
  },
];

const Pickupmemodocs = [
  {
    id: Math.random() * 10,
    name: "Pickup_Image_1",
    label: "Pickup Image 1",
  },
  {
    id: Math.random() * 10,
    name: "Pickup_Image_2",
    label: "Pickup Image 2",
  },
  {
    id: Math.random() * 10,
    name: "Pickup_Image_3",
    label: "Pickup Image 3",
  },
];

// const PickupMemoFreightCharges = [
//   {
//     id: Math.random() * 10,
//     name: "Freight_Charges",
//     fields: [
//       {
//         id: Math.random() * 10,
//         name: "Rent",
//         label: "Rent",
//         type: "number",
//         min: 1,
//         max: Infinity,
//       },
//     ],
//   },
// ];
const FreightCharges = [
  {
    id: Math.random() * 10,
    name: "Freight_Charges",
    fields: [
      {
        id: Math.random() * 10,
        name: "Total_Weight",
        label: "Total Weight",
        type: "number",
        min: 1,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Rate",
        label: "Rate",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Freight_On",
        label: "Freight On",
        type: "inputdrop",
        dropdowncontent: ["Weight", "Fixed"],
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Freight_Amount",
        label: "Freight Amount",
        type: "number",
        min: 1,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Docket_Amount",
        label: "Docket Amount",
        value: 0,
        type: "number",
        min: 1,
        max: Infinity,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Pickup_Charges",
      //   label: "Pickup Charges",
      //   type: "number",
      //   min: 1,
      //   max: Infinity,
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "Delivery_Charges",
      //   label: "Delivery Charges",
      //   type: "number",
      //   min: 1,
      //   max: Infinity,
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "FOV",
      //   label: "FOV",
      //   type: "number",
      //   min: 1,
      //   max: Infinity,
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "FSC",
      //   label: "FSC",
      //   type: "number",
      //   min: 1,
      //   max: Infinity,
      // },
      {
        id: Math.random() * 10,
        name: "Holding_Charge",
        label: "Holding Charge",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Hamali_Charge",
        label: "Hamali Charge",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Other_Charges",
        label: "Other Charges",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Other_Charges_Two",
        label: "Other Charges 2",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Total",
        label: "Total",
        formula: [
          { name: "Freight_Amount", opt: "+" },
          { name: "Docket_Amount", opt: "+" },
          { name: "Pickup_Charges", opt: "+" },
          { name: "Delivery_Charges", opt: "+" },
          { name: "FOV", opt: "+" },
          { name: "FSC", opt: "+" },
          { name: "Hamali_Charge", opt: "+" },
          { name: "Holding_Charge", opt: "+" },
          { name: "Other_Charges", opt: "+" },
          { name: "Other_Charges_Two", opt: "+" },
        ],
        type: "number",
        min: 1,
        max: Infinity,
        disabled: true,
      },
    ],
  },
];

export { PickupMemoFields, Pickupmemodocs, FreightCharges };
